import { render, staticRenderFns } from "./PasswordRecoveryReset.vue?vue&type=template&id=72cedabe&scoped=true"
import script from "./PasswordRecoveryReset.vue?vue&type=script&lang=js"
export * from "./PasswordRecoveryReset.vue?vue&type=script&lang=js"
import style0 from "./PasswordRecoveryReset.vue?vue&type=style&index=0&id=72cedabe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cedabe",
  null
  
)

export default component.exports